import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';

import * as State from '@shared/state';

@Component({
    selector: 'shared-vcard-for-wizzard',
    templateUrl: './vcard-for-wizzard.shared.component.html',
    styleUrls: ['./vcard-for-wizzard.shared.component.scss'],
})
export class VcardForWizzardComponent implements OnInit {
    public hasContent: boolean = false;

    @Input() public sidePaddings: boolean = false;
    @Input() public title: string;
    @Input() public description: string;
    @Input() public collapsed: boolean;

    @Input() public icon: boolean = false; /* Consumer -> shared-square-image */
    @Input() public imageSrc: string; /* Consumer -> shared-square-image */
    @Input() public stats: OLO.Components.IStatsComponentInput; /* Consumer -> shared-stats */
    @Input() public tagImages: State.IDietaryTagImage[]; /* Consumer -> shared-tag-images */
    @Input() public loading: boolean = false; /* Consumer -> shared-header, shared-square-image */
    @Input() public ellipsis: boolean = true; /* Consumer -> shared-header */
    @Input() public headerType: OLO.Components.HEADER_TYPE = '4'; /* Consumer -> shared-header */

    @ViewChild('content', { static: true }) public content: ElementRef;

    ngOnInit(): void {
        if (this.content.nativeElement && this.content.nativeElement.childNodes.length) {
            this.hasContent = true;
        }
    }

    public handleImageLoaded($event: Event): void {}
}
